import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import ErrorBoundary from '@nhl/nhl-react-ui/lib/ErrorBoundary';

import PageWrapper from 'media-base-ui/views/layouts/pageWrapper'

const NoMatch = lazy(() => import('media-base-ui/views/pages/noMatch'));

const Stories = lazy(() => import('../../pages/stories'));
const TeamStories = lazy(() => import('../../pages/teamStories'));
const LiveUpdates = lazy(() => import('../../pages/liveUpdates'));
const News = lazy(() => import('../../pages/news'));

const PublicApp = () => (
    <PageWrapper authenticated={false}>
        <ErrorBoundary>
            <Suspense fallback={<LoadingDisplay isLoading />}>
                <Routes>
                    <Route
                        path="/stories/:season/:name"
                        element={<Stories isPublic />}
                    />
                    <Route
                        path="/team-stories/:name"
                        element={<TeamStories isPublic />}
                    />
                    <Route
                        path="/news/:id"
                        element={<News isPublic />}
                    />
                    <Route
                        path="/live-updates"
                        element={<LiveUpdates isPublic />}
                    />
                    <Route component={NoMatch} />
                </Routes>
            </Suspense>
        </ErrorBoundary>
    </PageWrapper>
);

export default PublicApp;
